import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";

// Unregister any service workers (including old ones from cache)
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then(function(registrations) {
    for(let registration of registrations) {
      registration.unregister();
      console.log('Service Worker unregistered');
    }
  });
}

// index.html (and the server-rendered product pages) carry static SEO tags for
// crawlers that don't run JavaScript. Each page's SEOHead (react-helmet) adds its
// own, so drop the static ones first or the page ends up with two canonicals.
document
  .querySelectorAll(
    'head link[rel="canonical"]:not([data-rh]), head meta[name="description"]:not([data-rh]), ' +
      'head meta[name="keywords"]:not([data-rh]), head meta[name="robots"]:not([data-rh]), ' +
      'head meta[property^="og:"]:not([data-rh]), head meta[name^="twitter:"]:not([data-rh]), ' +
      'head script[data-seo="server"]'
  )
  .forEach((el) => el.remove());

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
